import { BaseSessionStorage } from '@golden/utils';
export class StartupStorage extends BaseSessionStorage {
    get launch() {
        if (!this.driver.exist(this.FIRST)) {
            return false;
        }
        return JSON.parse(this.driver.get(this.FIRST));
    }
    set launch(value) {
        if (value)
            this.driver.set(this.FIRST, JSON.stringify(value));
        else
            this.driver.remove(this.FIRST);
    }
    get downloadBannerClosed() {
        if (!this.driver.exist(this.DOWNLOADBANNERCLOSED)) {
            return false;
        }
        return JSON.parse(this.driver.get(this.DOWNLOADBANNERCLOSED));
    }
    set downloadBannerClosed(value) {
        if (value)
            this.driver.set(this.DOWNLOADBANNERCLOSED, JSON.stringify(value));
        else
            this.driver.remove(this.DOWNLOADBANNERCLOSED);
    }
    static getInstance() {
        return super.getInstance();
    }
    prefix = 'STARTUP';
    FIRST = 'LAUNCH';
    DOWNLOADBANNERCLOSED = 'DOWNLOADBANNERCLOSED';
}
//# sourceMappingURL=StartupStorage.js.map